import {EventSourceHandler} from '@sellsy/sse';

export default class UploadPdfFailedEventSourceHandler extends EventSourceHandler {

    constructor() {
        super()
        this.type = 'staff.uploadpdf.failed'
    }

    handle(event) {
        window.Push.error(event.data.message, event.data.title);
    }

}